import { useQuery } from '@tanstack/react-query';
import { getTeacherRoomCount } from '@/app/(teacher)/tools/actions';
import { roomQueryKeys } from '@/hooks/queryKeys';

export function useStudentRoomsCount(): number | null {
  const { data } = useQuery({
    queryKey: roomQueryKeys.count(),
    queryFn: () => getTeacherRoomCount().then((r) => r.data ?? 0),
  });

  return data ?? null;
}
